// extracted by mini-css-extract-plugin
export default {"error":"error--6292c6"};